<template>
  <div class="container mt-5">
    <vx-card title="Cuentas duplicadas">
      <vs-table :data="accounts">
        <template slot="thead">
          <vs-th>Cuenta referencia</vs-th>
          <vs-th>RFC/CURP</vs-th>
          <vs-th>Cuentas</vs-th>
          <vs-th>Opciones</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="account in data">
            <vs-td>{{account.stp_clabe}}</vs-td>
            <vs-td>{{account.rfcCurp}}</vs-td>
            <vs-td>{{account.counter}}</vs-td>
            <vs-td>
              <vs-button @click="showDialogStpAccountHandler(account.rfcCurp)">Corregir</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-popup
        fullscreen
        :title="`Cuentas de ${currentRfcCurp}`"
        :active.sync="showDialogStpAccount">

        <vs-table :data="accountOfRfc">
          <template slot="thead">
            <vs-th>Cuenta referencia</vs-th>
            <vs-th>IID</vs-th>
            <vs-th>CID</vs-th>
            <vs-th>SID</vs-th>
            <vs-th>F. creación</vs-th>
            <vs-th>Opciones</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr v-for="account in data">
              <vs-td>{{account.stp_clabe}}</vs-td>
              <vs-td>{{account.investor_id}}</vs-td>
              <vs-td>{{account.applicant_id}}</vs-td>
              <vs-td>{{account.supplier_id}}</vs-td>
              <vs-td>{{account.created_at|_humanizeDate}}</vs-td>
              <vs-td>
                <vs-button color="danger" @click="disabledAccountHandler(account.id)">Dar de baja</vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-popup>

      <otp-two-factor-authenticator
        style="z-index: 10000000"
        ref="otp" />
    </vx-card>
  </div>
</template>

<script>
import {_humanizeDate} from "@/filters/momentTzConvert"
import OtpTwoFactorAuthenticator from "@components/Otp/OtpTwoFactorAuthenticator";
export default {
  name: "StpAccountDuplicated",
  components: {OtpTwoFactorAuthenticator},
  data: () => ({
    accounts: [],
    accountOfRfc: [],
    showDialogStpAccount: false,
    currentRfcCurp: null
  }),
  filters: {
    _humanizeDate
  },
  async mounted() {
    const {data} = await axios.get(`/api/financials/stp/account/duplicates`)
    this.accounts = data;
  },
  methods: {
    async showDialogStpAccountHandler(rfcCurp) {
      this.showDialogStpAccount = true;
      this.currentRfcCurp = rfcCurp;

      const {data} = await axios.get(`/api/financials/stp/account/find?rfc_curp=${rfcCurp}`)
      this.accountOfRfc = data;
    },
    async disabledAccountHandler(stpAccountId) {
      //this.$refs.otp.show();

      /*this.$refs.otp.$on("confirm", async(answer) => {
          if (answer === true) {*/
            try {
              await axios.delete(`/api/financials/stp/account/${stpAccountId}`)
              await swal("Notificación", "La cuenta stp se dío de baja correctamente", "success")
            } catch (e) {
              await swal("Notificación", "Hubo un error al dar de baja la cuenta stp", "error")
            }
          /*}
      })*/
    }
  }
}
</script>

<style scoped>

</style>
